<template>
  <div>
    <v-simple-table>
      <tbody>
        <tr v-for="reason in reasons">
          <td>{{ reason }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'CustomReasonsList',
  props: {
    reasons: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.v-data-table {
  padding: 0 !important;

  max-height: 420px;
  overflow-y: auto;
}

tr {
  box-shadow: none !important;

  &:nth-child(2n) {
    background-color: $backGrey;
  }
}

td {
  text-align: left;
}
</style>
